import { FoldersRepository } from "@common/domain/repositories/FoldersRepository";
import {
  call,
  ForkEffect,
  put,
  select,
  takeEvery,
  takeLatest,
} from "redux-saga/effects";
import {
  bulkUpdateFormFolderPathFailureAction,
  bulkUpdateFormFolderPathSuccessAction,
  createFolderFailureAction,
  createFolderSuccessAction,
  deleteFolderFailureAction,
  deleteFolderSuccessAction,
  fetchFoldersByPathFailureAction,
  fetchFoldersByPathSuccessAction,
  foldersActions,
  getFolderByIdFailureAction,
  getFolderByIdSuccessAction,
  updateFolderFailureAction,
  updateFolderSuccessAction,
} from "./actions";
import { IBulkUpdateFormFolderPathAction, ICeateFolderAction, IDeleteFolderAction, IFetchFoldersByPathAction, IFetchFoldersByPathSuccessAction, IFoldersDataServer, IUpdateFolderAction } from "./interface";


function* fetchFolderByPathSaga(action: IFetchFoldersByPathAction) {
  try {
    const response: IFoldersDataServer[] = yield call(
      FoldersRepository.fetchFolders,
      action.payload
    );
    yield put(fetchFoldersByPathSuccessAction(response));
  } catch (e) {
    yield put(fetchFoldersByPathFailureAction({ error: e.message, }));
  }
}

function* createFolderSaga(action: ICeateFolderAction) {
  try {
    const response: IFoldersDataServer = yield call(
      FoldersRepository.createFolders,
      action.payload
    );
    yield put(createFolderSuccessAction(response));
  } catch (e) {
    yield put(createFolderFailureAction({ error: e.message, }));
  }
}

function* updateFolderSaga(action: IUpdateFolderAction) {
  try {
    yield put(updateFolderSuccessAction(action.payload));
  } catch (e) {
    yield put(updateFolderFailureAction({ error: e.message, }));
  }
}

function* deleteFolderSaga(action: IDeleteFolderAction) {
  try {
    const response = yield call(
      FoldersRepository.deleteFolders,
      action.payload
    );
    yield put(deleteFolderSuccessAction(action.payload));
  } catch (e) {
    yield put(deleteFolderFailureAction({ error: e.message, }));
  }
}

function* fetchFolderByIdSaga(action: IDeleteFolderAction) {
  try {
    const response = yield call(
      FoldersRepository.fetchFolderById,
      action.payload
    );

    yield put(getFolderByIdSuccessAction(response));
  } catch (e) {
    yield put(getFolderByIdFailureAction({ error: e.message, }));
  }
}


function* bulkUpdateFormFolderPathSaga(action: IBulkUpdateFormFolderPathAction) {
  try {
    const response = yield call(
      FoldersRepository.bulkUpdateFormFolderPath,
      action.payload
    );

    yield put(bulkUpdateFormFolderPathSuccessAction(response));
  } catch (e) {
    yield put(bulkUpdateFormFolderPathFailureAction({ error: e.message, }));
  }
}


export function* watchFolders(): Generator<ForkEffect> {
  yield takeLatest(foldersActions.FETCH_FOLDERS_BY_PATH, fetchFolderByPathSaga);
  yield takeLatest(foldersActions.CREATE_FOLDER, createFolderSaga);
  yield takeLatest(foldersActions.UPDATE_FOLDER, updateFolderSaga);
  yield takeLatest(foldersActions.DELETE_FOLDER, deleteFolderSaga);
  yield takeLatest(foldersActions.FETCH_FOLDER_BY_ID, fetchFolderByIdSaga);
  yield takeLatest(foldersActions.BULK_UPDATE_FORM_FOLDER_PATH, bulkUpdateFormFolderPathSaga);
}


const dummyResponse: IFoldersDataServer[] = [

  {
    "id": "64ef021406e5173fd4f787a5",
    "name": 'Folder-1',
    "userId": "8d9daef8-012a-4a8b-99da-ecb89cc12383",
    "folderPath": "/test",
    "createdDate": 1693385236179,
    "modifiedDate": 1693385236179,
    "sharedTo": null,
    "externalLink": null,
    "archived": false
  },
  {
    "id": "64ef024406e5173fd4f787a6",
    "name": "Folder-2",
    "userId": "8d9daef8-012a-4a8b-99da-ecb89cc12383",
    "folderPath": "/test",
    "createdDate": 1693385284205,
    "modifiedDate": 1693385284205,
    "sharedTo": null,
    "externalLink": null,
    "archived": true
  },
  {
    "id": "64ef024406e5173fd4f787a7",
    "name": "Folder-3",
    "userId": "8d9daef8-012a-4a8b-99da-ecb89cc12383",
    "folderPath": "/test",
    "createdDate": 1693385284206,
    "modifiedDate": 1693385284206,
    "sharedTo": null,
    "externalLink": null,
    "archived": true
  }

]
